import { render, staticRenderFns } from "./DealPredicLost.vue?vue&type=template&id=d3235e2c&scoped=true"
import script from "./DealPredicLost.vue?vue&type=script&lang=js"
export * from "./DealPredicLost.vue?vue&type=script&lang=js"
import style0 from "./DealPredicLost.vue?vue&type=style&index=0&id=d3235e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3235e2c",
  null
  
)

export default component.exports